<template>
    <div>
      <h2 class="mb-4">Biomasa</h2>
  
      <!-- Botón para nueva biomasa -->
      <button class="btn btn-primary mb-3" @click="openForm()">
        <font-awesome-icon icon="fas fa-tractor" class="me-1" /> Cosechar Biomasa
      </button>
  


      <!-- Lista de biomasa con colapsables -->
      <div v-for="b in biomasaList" :key="b.id" class="card mb-2">
        <div class="card-header d-flex justify-content-between align-items-center">
          <div>
            {{ b.fecha_cosecha.slice(0,10) }} — {{ tipoDescripcion(b.tipo_biomasa) }}
          </div>
          <button
            class="btn btn-sm btn-outline-secondary"
            @click="toggleDetails(b.id)"
          >
            {{ detailsOpen[b.id] ? 'Ocultar' : 'Detalles' }}
          </button>
        </div>
  
        <div v-if="detailsOpen[b.id]" class="card-body">
          <!-- Mostrar lote y código -->
          <p>
            <strong>Lote:</strong>
            <span v-if="b.planta_biomasa.length">
              {{ b.planta_biomasa[0].planta.lote.nombre }}
              <small class="text-muted">
                (Código: {{ b.planta_biomasa[0].planta.lote.codigo }})
              </small>
            </span>
            <span v-else>—</span>
          </p>
  
          <p><strong>Peso:</strong> {{ b.peso }} {{ b.unidad_medida }}</p>
          <p><strong>Observaciones:</strong> {{ b.observaciones || '—' }}</p>
  
          <!-- Toggle lista de plantas -->
          <button
            class="btn btn-sm btn-link p-0"
            @click="togglePlants(b.id)"
          >
            <font-awesome-icon icon="fas fa-seedling" class="me-1" />
            {{ plantsOpen[b.id] ? 'Ocultar Plantas' : 'Ver Plantas (' + b.planta_biomasa.length + ')' }}
          </button>
  
          <ul
            v-if="plantsOpen[b.id]"
            class="list-group mt-2"
            style="max-height: 200px; overflow-y: auto;"
          >
            <li
              v-for="p in b.planta_biomasa"
              :key="p.id"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              {{ p.planta.codigo }}
            </li>
            <li v-if="!b.planta_biomasa.length" class="list-group-item">
              No hay plantas vinculadas.
            </li>
          </ul>
  
          <div class="mt-3">
            <button class="btn btn-sm btn-warning" @click="openForm(b)">
              Editar
            </button>
          </div>
        </div>
      </div>
  
      <!-- Modal/Formulario -->
      <div class="modal fade" id="biomasaModal" tabindex="-1">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body p-0">
                    
              <BiomasaForm
                v-if="showForm"
                :proyecto_id="proyecto_id"
                :proyecto_evento_id="proyecto_evento_id"
                :biomasa="selectedBiomasa"
                @biomasaGuardada="onBiomasaGuardada"
                @cancel="closeForm"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from '@/axios'
  import { Modal } from 'bootstrap'
  import BiomasaForm from './biomasaForm.vue'
  
  export default {
    name: 'BiomasaManager',
    components: { BiomasaForm },
    props: {
      proyecto_id: { type: Number, required: true },
      proyecto_evento_id: { type: Number, required: true }
    },
    data() {
      return {
        biomasaList: [],
        tiposBiomasa: [],
        selectedBiomasa: null,
        showForm: false,
        detailsOpen: {},
        plantsOpen: {}
      }
    },
    async created() {

      await Promise.all([this.fetchBiomasa(), this.fetchTipos()])
    },
    methods: {
      async fetchBiomasa() {
        try {
          const res = await axios.get('/api/biomasa', {
            params: { proyecto_id: this.proyecto_id, include: 'planta_biomasa.planta.lote' }
          })
          this.biomasaList = res.data
          // Inicializar estados de colapso
          this.detailsOpen = {}
          this.plantsOpen = {}
          this.biomasaList.forEach(b => {
            this.detailsOpen[b.id] = false
            this.plantsOpen[b.id] = false
          })
        } catch (e) {
          console.error('Error cargando biomasa:', e)
        }
      },
      async fetchTipos() {
        try {
          const res = await axios.get('/api/constantes/tipos_biomasa')
          this.tiposBiomasa = res.data
        } catch (e) {
          console.error('Error cargando tipos de biomasa:', e)
        }
      },
      tipoDescripcion(id) {
        const t = this.tiposBiomasa.find(x => x.id === id)
        return t ? t.descripcion : id
      },
      toggleDetails(id) {
        this.$nextTick(() => {
          this.detailsOpen[id] = !this.detailsOpen[id]
          if (!this.detailsOpen[id]) this.plantsOpen[id] = false
        })
      },
      togglePlants(id) {
        this.$nextTick(() => {
          this.plantsOpen[id] = !this.plantsOpen[id]
        })
      },
      openForm(biomasa = null) {
        this.selectedBiomasa = biomasa
        this.showForm = true
        const modalEl = document.getElementById('biomasaModal')
        new Modal(modalEl).show()
      },
      closeForm() {
        this.showForm = false
        const modalEl = document.getElementById('biomasaModal')
        const instance = Modal.getInstance(modalEl)
        if (instance) instance.hide()
      },
      async onBiomasaGuardada() {
        this.closeForm()
        await this.fetchBiomasa()
      }
    }
  }
  </script>